<template>
    <b-row>
        <b-col sm="12" md="3" lg="3">
            <div class="p-3 text-center">
                <b-avatar class="m-3" size="6rem"/>
                <p class="text-bold">{{ subscriptor.email }}</p>
            </div>
            <b-list-group>
                <b-list-group-item>
                    <b>ID:</b> {{ subscriptor.id }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Nombre:</b> {{ subscriptor.nombre }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Apellidos:</b> {{ subscriptor.apellidos }}
                </b-list-group-item>
                <b-list-group-item>
                    <div class="d-flex align-items-center" style="gap: 0.5rem;">
                        <b>Reputación:</b>
                        <div id="rating-tooltip">
                            <star-rating
                                v-model="reputacionState"
                                :increment="0.5"
                                :star-size="22"
                                class="pb-1"
                                active-color="#444444"
                                inactive-color="#d3d3d3"
                                :show-rating="false"
                                @current-rating="currentRating = $event"
                                @rating-selected="actualizarReputacion"
                            />
                        </div>
                        <b-tooltip target="rating-tooltip" triggers="hover">
                            {{ currentRating }}
                        </b-tooltip>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Pais:</b> {{ subscriptor.pais }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Provincia:</b> {{ subscriptor.provincia }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Localidad:</b> {{ subscriptor.localidad }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Estado: </b> <b-badge :variant="subscriptor.activo ? 'success' : 'secondary'">{{ subscriptor.activo ? 'Activo' : 'Desactivado' }}</b-badge>
                </b-list-group-item>
            </b-list-group>
        </b-col>
        <b-col sm="12" md="9" lg="9">
            <b-tabs fill pills>
                <b-tab title="General" active>
                    <b-row class="pt-3">
                        <b-col sm="12" md="2" class="p-0 mx-auto">
                            <b-card class="h-75" body-class="p-2">
                                <b-card-text class="text-center">
                                    <p style="font-size: 2rem; margin-bottom: 0; font-weight: bold;">{{ subscriptor.total_emails_enviados }}</p>
                                    <p>Emails enviados</p>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col sm="12" md="2" class="p-0 mx-auto">
                            <b-card class="h-75" body-class="p-2">
                                <b-card-text class="text-center">
                                    <p style="font-size: 2rem; margin-bottom: 0; font-weight: bold;">{{ subscriptor.total_visulizaciones }}</p>
                                    <p>Visualizaciones</p>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col sm="12" md="2" class="p-0 mx-auto">
                            <b-card class="h-75" body-class="p-2">
                                <b-card-text class="text-center">
                                    <p style="font-size: 2rem; margin-bottom: 0; font-weight: bold;">{{ subscriptor.total_emails_clicados }}</p>
                                    <p>Clics</p>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col sm="12" md="2" class="p-0 mx-auto">
                            <b-card class="h-75" body-class="p-2">
                                <b-card-text class="text-center">
                                    <p style="font-size: 2rem; margin-bottom: 0; font-weight: bold;">{{ subscriptor.total_carritos_creados }}</p>
                                    <p>Entradas carritos</p>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col sm="12" md="2" lg="2" class="p-0 mx-auto">
                            <b-card class="h-75" body-class="p-2">
                                <b-card-text class="text-center">
                                    <p style="font-size: 2rem; margin-bottom: 0; font-weight: bold;">{{ subscriptor.total_entradas_compradas }}</p>
                                    <p>Entradas compradas</p>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col cols=12 class="pt-3">
                            <h4>Últimos eventos:</h4>
                            <hr/>
                            <TimeLineComponent
                                :events="subscriptor.actividades_recientes.map(evento => ({
                                    id: evento.id,
                                    icon: getIcon(evento.tipo_actividad),
                                    date: evento.created_at,
                                    title: getTitle(evento.tipo_actividad),
                                    message: getMessage(evento)
                                }))"
                            />
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Emails enviados" lazy>
                    <EmailsEnviados
                        :subscriptor="subscriptor"
                    />
                </b-tab>
                <b-tab title="Visualizaciones" lazy>
                    <EmailsVisualizaciones
                        :subscriptor="subscriptor"
                    />
                </b-tab>
                <b-tab title="Clics" lazy>
                    <EmailsClicks
                        :subscriptor="subscriptor"
                    />
                </b-tab>
                <b-tab title="Entradas carritos" lazy>
                    <EntradasCarrito
                        :subscriptor="subscriptor"
                    />
                </b-tab>
                <b-tab title="Entradas compradas" lazy>
                    <EntradasCompradas
                        :subscriptor="subscriptor"
                    />
                </b-tab>
            </b-tabs>
        </b-col>
    </b-row>
</template>

<script>
    import EmailsEnviados from '@/components/backend/campana-emails/subscriptores/detalle/EmailsEnviados';
    import TimeLineComponent from '@/components/common/TimeLineComponent.vue';
    import EmailsVisualizaciones from '../EmailsVisualizaciones.vue';
    import EmailsClicks from '../EmailsClicks.vue';
    import apiService from '@/services/api-comunicados';
    import StarRating from 'vue-star-rating'
    import EntradasCarrito from '../EntradasCarrito.vue';
    import EntradasCompradas from '../EntradasCompradas.vue';

    export default {
        name: 'InformacionTab',
        props: {
            subscriptor: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                reputacionState: parseFloat(this.subscriptor.reputacion),
                currentRating: null
            };
        },
        methods: {
            getIcon(evento) {
                switch (evento) {
                    case 'abierto':
                        return 'fa fa-envelope-open';
                    case 'clickado':
                        return 'fa fa-mouse-pointer';
                    case 'enviado':
                        return 'fa fa-paper-plane';
                    default:
                        return '';
                }
            },
            getMessage(evento) {
                switch (evento.tipo_actividad) {
                    case 'abierto':
                        return `Ha abierto el boletín <b><a href="/boletines/${evento.comunicado.id}" target="_blank">${evento.comunicado.asunto}</a></b>.`;
                    case 'clickado':
                        return `Ha hecho clic en el <b><a href="/boletines/${evento.comunicado.id}" target="_blank">${evento.comunicado.asunto}</a></b>.`;
                    case 'enviado':
                        return `Se ha enviado el boletín <b><a href="/boletines/${evento.comunicado.id}" target="_blank">${evento.comunicado.asunto}</a></b>.`;
                    default:
                        return '';
                }
            },
            getTitle(evento) {
                switch (evento) {
                    case 'abierto':
                        return 'Ha abierto el email';
                    case 'clickado':
                        return 'Clic';
                    case 'enviado':
                        return 'Email enviado';
                    default:
                        return '';
                }
            },

            async actualizarReputacion(nuevaReputacion){
                try {
                    await apiService.updateSubscriptor(this.subscriptor.id, { reputacion: nuevaReputacion});
                    this.$toast.success(`Reputación actualizda a ${nuevaReputacion} estrellas`)
                } catch {
                    this.$toast.error('Error al actualizar la reputación del subscriptor');
                }
            }
        },
        components: {
            EmailsEnviados, TimeLineComponent, EmailsVisualizaciones, EmailsClicks, EntradasCarrito, EntradasCompradas, StarRating
        }
    }
</script>
